/**
 * BreakdownExemption - synchronized with the Prisma enum of the same name.
 *
 * A compound ingredient carrying one of these is allowed to skip the Annex
 * VII Part E component list at the confirmation gate (Reg. (UE) 1169/2011,
 * Annex VII Part E point 2): (a) composition laid down by EU law and the
 * ingredient under 2% of the finished product; (b) spice/herb mix under 1%
 * of the finished product. The two thresholds are NOT interchangeable.
 */
export const BREAKDOWN_EXEMPTIONS = [
  'EU_DEFINED_UNDER_2PCT',
  'SPICE_MIX_UNDER_1PCT',
  'NO_LIST_REQUIRED',
] as const;
export type BreakdownExemption = (typeof BREAKDOWN_EXEMPTIONS)[number];
